define(function(require, exports) {
    'use strict';

    // @NgInject
    exports.tulipProvider = function() {

        // @ngInject
        /**
         * @param {ng.IHttpService} $http
         */
        this.$get = function tulipFactory($http, lpCoreUtils, lpCoreBus) {
            var config = {
                getTulipSessionUrl: lpCoreUtils.resolvePortalPlaceholders('$(servicesPath)/services/rest/fraud/session/identifier'),
                toggleTulip: '/portalserver/services/rest/config'
            };

            function tulip(pageId){
                if(window.tmx_profiling_started){
                    document.getElementById('tulipstag').remove();
                    window.tmx_profiling_started = false;
                }
                getConfigData().then(function(response){
                    if(response && response.data && response.data.fraudServerUrl && response.data.fraudOrgId){
                        injectScript({
                            fraudServerUrl : response.data.fraudServerUrl,
                            fraudOrgId : response.data.fraudOrgId,
                            pageId : pageId,
                          });
                    }
                });
            }

            function createScript(data) {
                // inject script tag
                if(window.tmx_profiling_started){
                    document.getElementById('tulipstag').remove();
                    window.tmx_profiling_started = false;
                }
                if(data.fraudServerUrl && data.fraudOrgId){
                   injectScript(data);
                }
            }

            function injectScript(config) {
                   
                    var scriptElem = document.createElement('script');
                    scriptElem.id = "tulipstag";
                    scriptElem.type = 'text/javascript';
                    scriptElem.src = config.fraudServerUrl + '/fp/tags.js?org_id='+ config.fraudOrgId
                        + '&session_id=' + generateSession() + '&page_id='+ config.pageId;
                    document.head.append(scriptElem);

            }

            function generateSession(){
                var dt = new Date().getTime();
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    var r = (dt + Math.random()*16)%16 | 0;
                    dt = Math.floor(dt/16);
                    return (c=='x' ? r :(r&0x3|0x8)).toString(16);
                });
                lpCoreBus.publish('tulip:publish-session-id', uuid);
                return uuid;
            }
          
            function getConfigData(){
               return $http.get(config.toggleTulip);
            }
            
            return {
                tulip:tulip,
                getConfigData:getConfigData,
                createScript:createScript,
            };
        };
    };
});



// WEBPACK FOOTER //
// ./scripts/tulipFactory.js